import { styled } from 'stitches.config'
import Flex from 'components/primitives/Flex'
import {
  ComponentPropsWithoutRef,
  ElementRef,
  forwardRef,
  ReactNode,
} from 'react'
import { CSS } from '@stitches/react'

const StyledInput = styled('input', {
  all: 'unset',
  width: '100%',
  px: 16,
  py: 12,
  borderRadius: 8,
  fontFamily: '$body',
  fontSize: 16,
  color: '$gray12',
  backgroundColor: '$gray3',
  // Glossy inset depth
  backgroundImage:
    'linear-gradient(180deg, rgba(0,0,0,0.04), rgba(255,255,255,0.04))',
  border: '1px solid $gray6',
  boxShadow: 'inset 0 2px 6px rgba(0, 0, 0, 0.06)',
  transition:
    'box-shadow 250ms cubic-bezier(0.22, 1, 0.36, 1), background-color 200ms ease, border-color 200ms ease',
  $$focusColor: '$colors$primary8',
  '&::placeholder': { color: '$gray10' },
  '&:hover': { backgroundColor: '$gray4' },
  '&:focus': {
    backgroundColor: '$gray3',
    borderColor: '$$focusColor',
    boxShadow:
      'inset 0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 4px rgba(99, 102, 241, 0.18)',
  },
  '&:disabled': {
    backgroundColor: '$gray2',
    color: '$gray9',
  },

  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },

  '&[type=number]': {
    '-moz-appearance': 'textfield',
  },
})

const Input = forwardRef<
  ElementRef<typeof StyledInput>,
  ComponentPropsWithoutRef<typeof StyledInput> & {
    icon?: ReactNode
    containerCss?: CSS
  }
>(({ children, icon, containerCss, ...props }, forwardedRef) => (
  <Flex css={{ ...containerCss, position: 'relative' }}>
    {icon && (
      <div style={{ position: 'absolute', top: 16, left: 16 }}>{icon}</div>
    )}
    <StyledInput css={{ pl: icon ? 48 : 16 }} ref={forwardedRef} {...props} />
  </Flex>
))

export default Input
